"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = void 0;
exports.Style = {
    SUPERIMPOSE: 'flex-direction: column;display: inline-flex;justify-content: center;text-align: left;vertical-align: middle;',
    SUPERIMPOSE_SUP_SUB: 'line-height: 1; font-size: 70%',
};
//# sourceMappingURL=Style.js.map